<div class="bp-modal mod-lg favourite-modal-mobile">
	<!-- Header -->
	<bp-modal-header [title]="'coins_title' | translate">
		<a right (click)="close()" class="large-weight" (keydown.enter)="close()" [tabindex]="0">
			{{ "abort" | translate }}
		</a>
	</bp-modal-header>
	<!-- Body -->
	<div class="bp-modal-body text-center">
		<!-- Tradable select -->
		<tradable-list-item
			[isFavourites]="true"
			action="buy"
			[customListFilter]="filterTradableList"
			[(selectedList)]="selectedAssets"
			(onRefresh)="doTrapFocusTime()">
		</tradable-list-item>
		<div class="justify-center border">
			<button
				(click)="addToFavourites()"
				class="btn btn-primary btn-lg"
				[disabled]="getSelectedLength().length < 1">
				{{ "watchlist_add_assets_button_title" | translate }} {{ getSelectedLength() }}
			</button>
		</div>
	</div>
</div>
